import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/pages/dashboard/components/DashboardLayout';
import ListingForm from '@/pages/dashboard/listings/components/ListingForm';
import { useAuth } from '@/context/AuthContext';

function ListingNew() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50">Nouvelle annonce</h1>
        <p className="text-sm text-foreground-400 mt-1">
          Publiez un produit à vendre ou une annonce / offre.
        </p>
      </div>

      <div className="max-w-3xl">
        <ListingForm ownerId={user.id} onSaved={() => navigate('/dashboard/listings')} />
      </div>
    </DashboardLayout>
  );
}

export default ListingNew;